// src/utils/permissionUtils.js

/**
 * Determines user role information
 * @param {Object} user - The user object containing role information
 * @returns {Object} - Object containing role information
 */
export const getUserRoleInfo = (user) => {
    // Default role info
    const roleInfo = {
        isAdmin: false,
        isTenantManager: false,
        isNodeUser: false,
        isStandardUser: false,
    };

    // Return default role info if no user or role
    if (!user || !user.role) return roleInfo;

    const role = user.role.toLowerCase();

    if (role === "admin") {
        roleInfo.isAdmin = true;
    } else if (role === "sct_tenant_manager") {
        roleInfo.isTenantManager = true;
    } else if (role === "sct_node_user") {
        roleInfo.isNodeUser = true;
    } else {
        roleInfo.isStandardUser = true;
    }

    return roleInfo;
};

/**
 * Checks if user is an admin
 * @param {Object} user - The user object
 * @returns {boolean} - Whether user is an admin
 */
export const isAdmin = (user) => {
    if (!user || !user.role) return false;
    return user.role.toLowerCase() === "admin";
};

/**
 * Checks if user is a tenant manager
 * @param {Object} user - The user object
 * @returns {boolean} - Whether user is a tenant manager
 */
export const isTenantManager = (user) => {
    if (!user || !user.role) return false;
    return user.role.toLowerCase() === "sct_tenant_manager";
};

/**
 * Checks if user is a node user
 * @param {Object} user - The user object
 * @returns {boolean} - Whether user is a node user
 */
export const isNodeUser = (user) => {
    if (!user || !user.role) return false;
    return user.role.toLowerCase() === "sct_node_user";
};

/**
 * Checks if user has admin level access
 * @param {Object} user - The user object
 * @returns {boolean} - Whether user has admin level access
 */
export const hasAdminAccess = (user) => {
    return isAdmin(user) || isTenantManager(user);
};
